import Vue from 'vue'
import Router from 'vue-router'
const Login = () =>
  import ('../views/login')
const Menu = () =>
  import ('../views/menu/menu.vue')
const IsolationSituation = () =>
  import ('../views/isolation-situation/isolation-situation.vue')
const SpecialIsolationSituation = () => 
  import ('../views/special-isolation-situation/special-isolation-situation.vue')
const MedicalWasteRecord = () =>
  import ('../views/medical-waste-record/medical-waste-record.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/isolation-situation',
      name: 'IsolationSituation',
      component: IsolationSituation
    },
    {
      path: "/menu",
      name: 'Menu',
      component: Menu
    },
    {
      path: '/special-isolation-situation',
      name: 'SpecialIsolationSituation',
      component: SpecialIsolationSituation
    },
    {
      path: '/medical-waste-record',
      name: 'MedicalWasteRecord',
      component: MedicalWasteRecord
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js